module.exports = __webpack_public_path__ + "img/NLC-S-front.8a786eae.jpg";